import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=31a38ff4"
import script from "@/scripts/adminManager/banner/banner.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/banner/banner.js?vue&type=script&lang=js&external"
import style0 from "./Banner.vue?vue&type=style&index=0&id=31a38ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports